










 

 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SetTeamNotificationSettingMutation_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamNotificationSettings",
      "kind": "LinkedField",
      "name": "teamNotificationSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "events",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SetTeamNotificationSettingSuccess",
  "abstractKey": null
};

(node ).hash = "92f8200438c6cbe1aa96875a9aacc401";

export default node;
